import { QueryClient } from '@tanstack/react-query';

/**
 * Factory so tests can build isolated QueryClient instances without sharing cache.
 * Defaults per 03-CONTEXT.md D-31.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // 30s
        gcTime: 5 * 60 * 1000, // 5min
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
